<template>
	<div v-if="showErrors" :class="{'rate-field-error-container': true, 'rate-field-error-left': alignment == 'left', 'rate-field-error-right': alignment == 'right'}">
		<div class="rate-field-error" :style="{minWidth: minWidth}">
			<ul>
				<li v-for="(err, i) in errors" v-bind:key="i" v-html="err"></li>
				<li v-on:click="hide">Close</li>
			</ul>
		</div>
	</div>
</template>

<style lang="scss">
.rate-field-error-container {
	position: relative;
	.rate-field-error {
		position: absolute;
		bottom: 0;
		background-color: rgb(255, 167, 167);
		border: 1px solid #ff0000;
		color: #ff0000;
		> ul {
			margin: 0;
			padding: 3px;
			list-style-type: none;
			font-size: 0.8em;
			> li {
				max-height: 100px;
				overflow: auto;
			}
			> li:last-child {
				text-align: right;
				cursor: pointer;
			}
		}
	}
	&.rate-field-error-left {
		.rate-field-error {
			left: 0;
		}
	}
	&.rate-field-error-right {
		.rate-field-error {
			right: 0;
		}
	}
}
</style>

<script>
export default {
	props: {
		errors: {
			type: Array,
			default: [],
		},
		minWidth: {
			type: [String,Number],
			default: '130px',
		},
		alignment: {
			type: String,
			default: 'left',
		}
	},
	data () {
		return {
			visible: true,
		}
	},
	computed: {
		showErrors () {
			return this.errors.length > 0 && this.visible;
		}
	},
	methods: {
		hide() {
			this.visible = false;
		}
	}
}
</script>
